import { create } from "zustand";

interface IpRestrictionState {
	/** 組織の接続元 IP 制限で API が拒否された。再読み込みまで戻さない。 */
	blocked: boolean;
	markBlocked: () => void;
}

export const useIpRestrictionStore = create<IpRestrictionState>((set) => ({
	blocked: false,
	markBlocked: () => set({ blocked: true }),
}));
